import React, { useEffect, useState } from 'react';
import pause from '../images/pause.svg';
import styles from './playback-status.css';

export const PlaybackStatus = () => {
  const playerManager = cast.framework.CastReceiverContext.getInstance().getPlayerManager();
  const [paused, setPaused] = useState(false);
  const [buffering, setBuffering] = useState(true);

  useEffect(() => {
    playerManager.addEventListener(cast.framework.events.EventType.PAUSE, onPause);
    playerManager.addEventListener(cast.framework.events.EventType.PLAY, onPlay);
    playerManager.addEventListener(cast.framework.events.EventType.BUFFERING, onBuffering);

    return () => {
      playerManager.removeEventListener(cast.framework.events.EventType.PAUSE, onPause);
      playerManager.removeEventListener(cast.framework.events.EventType.PLAY, onPlay);
      playerManager.removeEventListener(cast.framework.events.EventType.BUFFERING, onBuffering);
    };
  }, []);

  /**
   * Shows buffering.
   * @param {Object} data information.
   * @param {boolean} data.isBuffering Buffering status.
   */
  function onBuffering({ isBuffering }) {
    setBuffering(isBuffering);
  }

  /**
   * Shows pause button.
   */
  function onPause() {
    setPaused(true);
  }

  /**
   * Remove spause button.
   */
  function onPlay() {
    setPaused(false);
  }

  return (
    <>
      {buffering ? (
        <span className={styles.buffering}></span>
      ) : (
        paused && <img className={styles.pause} src={pause} />
      )}
    </>
  );
};
